module.exports = __webpack_public_path__ + "img/ringcase@2x.ccd7b2f.jpg";